/**
 * The currency refusals (docs/clinic-currency/CONTRACTS.md §2, §11.9), in the
 * reader's language.
 *
 * The BFF lifts each service's `error-code` into `extensions.code`. The copy lives
 * HERE rather than in the server's sentence: a coded refusal is one we have written
 * words for, and the wire's sentence is only the fallback for a code nobody
 * anticipated (the rule `screens/Onboarding/errors.js` states for the same reason).
 */
export const CURRENCY_ERROR_KEYS = Object.freeze({
  INVALID_CURRENCY: 'errors.currency.invalid',
  CURRENCY_LOCKED: 'errors.currency.locked',
  CURRENCY_MISMATCH: 'errors.currency.mismatch',
  MIXED_CURRENCY: 'errors.currency.mixed',
  RAIL_REQUIRES_IRR: 'errors.currency.railRequiresIrr',
  CURRENCY_CHANGE_INCOMPLETE: 'errors.currency.changeIncomplete',
});

/** The code of a thrown BFF error, wherever the transport put it. */
export function errorCodeOf(err) {
  return err?.extensions?.code
    || err?.graphQLErrors?.[0]?.extensions?.code
    || (Array.isArray(err?.errors) ? err.errors[0]?.extensions?.code : '')
    || '';
}

/** The catalogue sentence for a currency refusal, or '' for any other error. */
export function currencyErrorMessage(err, t) {
  const key = CURRENCY_ERROR_KEYS[errorCodeOf(err)];
  return key ? t(key) : '';
}

/**
 * What a money screen shows for a failed act: our words for a currency refusal,
 * else the server's own sentence, else ''. Callers keep their own fallback:
 *   setError(moneyErrorText(e, t) || t('errors.cashier.paymentFailed'));
 */
export function moneyErrorText(err, t) {
  return currencyErrorMessage(err, t) || err?.message || '';
}
